import LayoutContent from './LayoutContent';
export default LayoutContent;
